import { Divider } from '@shared/components';

export const TaskDivider = () => {
  return <Divider $style={{ marginTop: '8px', marginBottom: '8px' }} />;
};
